import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { ThirdPartyPayoff } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface SetThirdPartyPayoffBuyerAssumptionRequest {
    engagementId: number;
    tableRowId: number;
    isAssumedByBuyer: boolean;
}

export const SetThirdPartyPayoffBuyerAssumption = createAsyncThunk(
    'flowOfFunds/setThirdPartyPayoffBuyerAssumption',
    async (params: SetThirdPartyPayoffBuyerAssumptionRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}/buyerAssumption`,
                {
                    isAssumedByBuyer: params.isAssumedByBuyer,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the buyer assumption');
            }

            return response.data as ThirdPartyPayoff;
        } catch (error) {
            createNotification('Could not save the buyer assumption.', 'error');
            throw error;
        }
    }
);
